module.exports = __webpack_public_path__ + "media/images/pillar_influencers-d075ba7c3ff71bcfb08ee95785f47165.jpg";